import gql from 'graphql-tag';
import { REPORT_ITEM_FRAGMENT } from './fragments/reportItem.fragment';

export const GET_REPORT = gql`
  query PullBPFReport($input: BPFReportInput!) {
    bpf {
      report {
        result: pullBPFReport(input: $input) {
          error
          success
          entity {
            list {
              name

              meta {
                label
                invoiceSubTotal
              }

              data {
                ...ReportItemFields
              }
            }

            summary {
              data {
                stageId
                dealsSum
                stageName
                department
                dealsAmount
              }
              dealsSum
              dealsAmount
            }
          }
        }
      }
    }
  }
  ${REPORT_ITEM_FRAGMENT}
`;
